import Vue from 'vue';

// 使用 Event Bus
const color2 = new Vue();

export default color2;



// WEBPACK FOOTER //
// ./src/view/framework/home/color1.js